import $apiJSON from '../http/apiJSON'

// Press API Service - Пресса, новости и медиаконтент

// Пресс-статьи
export async function getPressArticles(params = {}) {
  return $apiJSON.get('media/press/', { params })
}

export async function getPressArticle(slug) {
  return $apiJSON.get(`media/press/${slug}/`)
}

export async function createPressArticle(data) {
  return $apiJSON.post('media/press/', data)
}

export async function updatePressArticle(slug, data) {
  return $apiJSON.put(`media/press/${slug}/`, data)
}

export async function deletePressArticle(slug) {
  return $apiJSON.delete(`media/press/${slug}/`)
}

export async function likePressArticle(slug) {
  return $apiJSON.post(`media/press/${slug}/like/`)
}

export async function getPressArticleComments(slug) {
  return $apiJSON.get(`media/press/${slug}/comments/`)
}

export async function addPressArticleComment(slug, content) {
  return $apiJSON.post(`media/press/${slug}/comments/`, { body: content })
}

// Новости
export async function getNews(params = {}) {
  return $apiJSON.get('media/news/', { params })
}

export async function getNewsArticle(slug) {
  return $apiJSON.get(`media/news/${slug}/`)
}

export async function createNewsArticle(data) {
  return $apiJSON.post('media/news/', data)
}

export async function updateNewsArticle(slug, data) {
  return $apiJSON.put(`media/news/${slug}/`, data)
}

export async function deleteNewsArticle(slug) {
  return $apiJSON.delete(`media/news/${slug}/`)
}

export async function rateNewsArticle(slug, rating) {
  return $apiJSON.post(`media/news/${slug}/rate/`, { rating })
}

export async function likeNewsArticle(slug) {
  return $apiJSON.post(`media/news/${slug}/like/`)
}

export async function getNewsCategories() {
  return $apiJSON.get('media/news/categories/')
}

// Видео-обзоры
export async function getVideoReviews(params = {}) {
  return $apiJSON.get('media/reviews/', { params })
}

export async function getVideoReview(slug) {
  return $apiJSON.get(`media/reviews/${slug}/`)
}

export async function createVideoReview(data) {
  return $apiJSON.post('media/reviews/', data)
}

export async function updateVideoReview(slug, data) {
  return $apiJSON.put(`media/reviews/${slug}/`, data)
}

export async function deleteVideoReview(slug) {
  return $apiJSON.delete(`media/reviews/${slug}/`)
}

export async function rateVideoReview(slug, rating) {
  return $apiJSON.post(`media/reviews/${slug}/rate/`, { rating })
}

export async function likeVideoReview(slug) {
  return $apiJSON.post(`media/reviews/${slug}/like/`)
}

// Let's Play видео
export async function getLetsPlayVideos(params = {}) {
  return $apiJSON.get('media/letsplay/', { params })
}

export async function getLetsPlayVideo(slug) {
  return $apiJSON.get(`media/letsplay/${slug}/`)
}

export async function createLetsPlayVideo(data) {
  return $apiJSON.post('media/letsplay/', data)
}

export async function updateLetsPlayVideo(slug, data) {
  return $apiJSON.put(`media/letsplay/${slug}/`, data)
}

export async function deleteLetsPlayVideo(slug) {
  return $apiJSON.delete(`media/letsplay/${slug}/`)
}

export async function rateLetsPlayVideo(slug, rating) {
  return $apiJSON.post(`media/letsplay/${slug}/rate/`, { rating })
}

export async function likeLetsPlayVideo(slug) {
  return $apiJSON.post(`media/letsplay/${slug}/like/`)
}

export async function getAllLetsPlayByGames() {
  return $apiJSON.get('media/letsplay/by-game/')
}

// Стримеры
export async function getStreamers(params = {}) {
  return $apiJSON.get('media/streamers/', { params })
}

export async function getStreamer(slug) {
  return $apiJSON.get(`media/streamers/${slug}/`)
}

export async function createStreamer(data) {
  return $apiJSON.post('media/streamers/', data)
}

export async function updateStreamer(slug, data) {
  return $apiJSON.put(`media/streamers/${slug}/`, data)
}

export async function deleteStreamer(slug) {
  return $apiJSON.delete(`media/streamers/${slug}/`)
}

export async function rateStreamer(slug, rating) {
  return $apiJSON.post(`media/streamers/${slug}/rate/`, { rating })
}

export async function likeStreamer(slug) {
  return $apiJSON.post(`media/streamers/${slug}/like/`)
}

// Комментарии (универсальные)
export async function getMediaComments(params = {}) {
  return $apiJSON.get('media/comments/', { params })
}

export async function createMediaComment(data) {
  return $apiJSON.post('media/comments/', data)
}

export async function updateMediaComment(id, data) {
  return $apiJSON.put(`media/comments/${id}/`, data)
}

export async function deleteMediaComment(id) {
  return $apiJSON.delete(`media/comments/${id}/`)
}

// Поиск и фильтрация
export async function searchPress(query, params = {}) {
  return $apiJSON.get('media/press/', { params: { search: query, ...params } })
}

export async function searchNews(query, params = {}) {
  return $apiJSON.get('media/news/', { params: { search: query, ...params } })
}

export async function searchVideoReviews(query, params = {}) {
  return $apiJSON.get('media/reviews/', { params: { search: query, ...params } })
}

export async function searchLetsPlay(query, params = {}) {
  return $apiJSON.get('media/letsplay/', { params: { search: query, ...params } })
}

export async function searchStreamers(query, params = {}) {
  return $apiJSON.get('media/streamers/', { params: { search: query, ...params } })
}

export async function searchAllMedia(query) {
  // Выполняем поиск по всем типам контента параллельно
  const [press, news, reviews, letsplay, streamers] = await Promise.all([
    searchPress(query).catch(() => ({ data: [] })),
    searchNews(query).catch(() => ({ data: [] })),
    searchVideoReviews(query).catch(() => ({ data: [] })),
    searchLetsPlay(query).catch(() => ({ data: [] })),
    searchStreamers(query).catch(() => ({ data: [] }))
  ])

  return {
    press: press.data.results || press.data || [],
    news: news.data.results || news.data || [],
    reviews: reviews.data.results || reviews.data || [],
    letsplay: letsplay.data.results || letsplay.data || [],
    streamers: streamers.data.results || streamers.data || []
  }
}

// Популярный и рекомендуемый контент
export async function getFeaturedPress() {
  return $apiJSON.get('media/press/', { params: { featured: true } })
}

export async function getFeaturedNews() {
  return $apiJSON.get('media/news/', { params: { featured: true } })
}

export async function getFeaturedVideoReviews() {
  return $apiJSON.get('media/reviews/', { params: { featured: true } })
}

export async function getFeaturedLetsPlay() {
  return $apiJSON.get('media/letsplay/', { params: { featured: true } })
}

export async function getPopularVideoReviews() {
  return $apiJSON.get('media/reviews/', { params: { ordering: '-views_count' } })
}

export async function getPopularLetsPlay() {
  return $apiJSON.get('media/letsplay/', { params: { ordering: '-views_count' } })
}

export async function getPopularNews() {
  return $apiJSON.get('media/news/', { params: { ordering: '-views_count' } })
}

export async function getTrendingStreamers() {
  return $apiJSON.get('media/streamers/', { params: { ordering: '-followers_count' } })
}

export async function getVerifiedStreamers() {
  return $apiJSON.get('media/streamers/', { params: { verified: true } })
}

// Категории и фильтры
export async function getNewsByCategory(category, params = {}) {
  return $apiJSON.get('media/news/', { params: { category, ...params } })
}

export async function getLetsPlayByGame(game, params = {}) {
  return $apiJSON.get('media/letsplay/', { params: { game, ...params } })
}

export async function getStreamersByGame(game, params = {}) {
  return $apiJSON.get('media/streamers/', { params: { game, ...params } })
}

export async function getPressBySource(source, params = {}) {
  return $apiJSON.get('media/press/', { params: { source, ...params } })
}

// Статистика
export async function getMediaStats() {
  return $apiJSON.get('media/stats/')
}

// Универсальные функции для лайков и комментариев
export async function addMediaLike(mediaId, mediaType) {
  const endpoints = {
    press: `media/press/${mediaId}/like/`,
    news: `media/news/${mediaId}/like/`,
    reviews: `media/reviews/${mediaId}/rate/`, // для reviews используем рейтинг
    letsplay: `media/letsplay/${mediaId}/rate/`,
    streamers: `media/streamers/${mediaId}/like/`
  }
  
  const endpoint = endpoints[mediaType]
  if (!endpoint) {
    throw new Error(`Unsupported media type: ${mediaType}`)
  }
  
  return $apiJSON.post(endpoint, mediaType.includes('review') || mediaType === 'letsplay' ? { rating: 5 } : {})
}

export async function addMediaComment(mediaId, mediaType, content) {
  const endpoints = {
    press: `media/press/${mediaId}/comments/`,
    news: `media/news/${mediaId}/comments/`,
    reviews: `media/reviews/${mediaId}/comments/`,
    letsplay: `media/letsplay/${mediaId}/comments/`,
    streamers: `media/streamers/${mediaId}/comments/`
  }
  
  const endpoint = endpoints[mediaType]
  if (!endpoint) {
    throw new Error(`Unsupported media type: ${mediaType}`)
  }
  
  return $apiJSON.post(endpoint, { body: content })
}

export async function getMediaCommentsByItem(mediaId, mediaType) {
  const endpoints = {
    press: `media/press/${mediaId}/comments/`,
    news: `media/news/${mediaId}/comments/`,
    reviews: `media/reviews/${mediaId}/comments/`,
    letsplay: `media/letsplay/${mediaId}/comments/`,
    streamers: `media/streamers/${mediaId}/comments/`
  }
  
  const endpoint = endpoints[mediaType]
  if (!endpoint) {
    throw new Error(`Unsupported media type: ${mediaType}`)
  }
  
  return $apiJSON.get(endpoint)
}

// Класс-обертка для удобства использования
class MediaService {
  // Press
  static getPressArticles = getPressArticles
  static getPressArticle = getPressArticle
  static createPressArticle = createPressArticle
  static updatePressArticle = updatePressArticle
  static deletePressArticle = deletePressArticle
  static likePressArticle = likePressArticle
  
  // News
  static getNews = getNews
  static getNewsArticle = getNewsArticle
  static getNewsCategories = getNewsCategories
  static createNewsArticle = createNewsArticle
  static updateNewsArticle = updateNewsArticle
  static deleteNewsArticle = deleteNewsArticle
  static rateNewsArticle = rateNewsArticle
  static likeNewsArticle = likeNewsArticle
  
  // Video Reviews
  static getVideoReviews = getVideoReviews
  static getVideoReview = getVideoReview
  static createVideoReview = createVideoReview
  static updateVideoReview = updateVideoReview
  static deleteVideoReview = deleteVideoReview
  static rateVideoReview = rateVideoReview
  static likeVideoReview = likeVideoReview
  
  // Let's Play
  static getLetsPlayVideos = getLetsPlayVideos
  static getLetsPlayVideo = getLetsPlayVideo
  static createLetsPlayVideo = createLetsPlayVideo
  static updateLetsPlayVideo = updateLetsPlayVideo
  static deleteLetsPlayVideo = deleteLetsPlayVideo
  static rateLetsPlayVideo = rateLetsPlayVideo
  static likeLetsPlayVideo = likeLetsPlayVideo
  static getAllLetsPlayByGames = getAllLetsPlayByGames
  
  // Streamers
  static getStreamers = getStreamers
  static getStreamer = getStreamer
  static createStreamer = createStreamer
  static updateStreamer = updateStreamer
  static deleteStreamer = deleteStreamer
  static rateStreamer = rateStreamer
  static likeStreamer = likeStreamer
  static getTrendingStreamers = getTrendingStreamers
  static getVerifiedStreamers = getVerifiedStreamers
  
  // Search
  static searchAllMedia = searchAllMedia
  static searchPress = searchPress
  static searchNews = searchNews
  static searchVideoReviews = searchVideoReviews
  static searchLetsPlay = searchLetsPlay
  static searchStreamers = searchStreamers
  
  // Popular content
  static getFeaturedPress = getFeaturedPress
  static getFeaturedNews = getFeaturedNews
  static getFeaturedVideoReviews = getFeaturedVideoReviews
  static getFeaturedLetsPlay = getFeaturedLetsPlay
  static getPopularVideoReviews = getPopularVideoReviews
  static getPopularLetsPlay = getPopularLetsPlay
  static getPopularNews = getPopularNews
  
  // Categories
  static getNewsByCategory = getNewsByCategory
  static getLetsPlayByGame = getLetsPlayByGame
  static getStreamersByGame = getStreamersByGame
  static getPressBySource = getPressBySource
  
  // Interactions
  static addMediaLike = addMediaLike
  static addMediaComment = addMediaComment
  static getMediaCommentsByItem = getMediaCommentsByItem
  
  // Stats
  static getMediaStats = getMediaStats
  
  // Legacy aliases
  static getMediaContent = getFeaturedPress
  static getMediaFiles = getPressArticles
  static uploadMediaFile = createPressArticle
  static searchMediaFiles = searchAllMedia
}

export default MediaService